import { render } from "./LastExpense.vue?vue&type=template&id=ec25defa&scoped=true"
import script from "./LastExpense.vue?vue&type=script&lang=js"
export * from "./LastExpense.vue?vue&type=script&lang=js"

import "./LastExpense.vue?vue&type=style&index=0&id=ec25defa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec25defa"]])

export default __exports__